"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RESTRICT_LEGIT_INTEREST_PROCESSING = exports.REGIME_DISPLAY_PRIORITY = exports.REGIME_TIMEZONES = exports.DEFAULT_EXPERIENCE_PURPOSE_SCOPES = exports.DEFAULT_EXPERIENCE_PURPOSE_OPT_OUTS = exports.DEFAULT_REGIME_PURPOSE_OPT_OUTS = exports.DEFAULT_REGIME_TRACKING_PURPOSE_SCOPES = exports.GDPR_PURPOSES = exports.UNKNOWN_DEFAULT_EXPERIENCE = void 0;
/* --------------------------------------------------------------------------------
 * NOTE: PLEASE DON'T IMPORT ANYTHING BESIDES TYPES INTO THIS FILE.
 * (or make -absolutely- certain it leaves a miniscule build footprint).
 * Constants from this file are imported directly into airgap (core/init.ts)
 * and if you import something that leaves traces it -will- bloat the airgap build.
 * -------------------------------------------------------------------------------- */
exports.UNKNOWN_DEFAULT_EXPERIENCE = 'Unknown';
exports.GDPR_PURPOSES = [
    ['GDPR', 'LGPD', 'nFADP'],
    ['Advertising', 'Analytics', 'Functional'],
];
exports.DEFAULT_REGIME_TRACKING_PURPOSE_SCOPES = [
    exports.GDPR_PURPOSES,
    [['CPRA', 'CDPA', 'CPA', 'NEVADA_SB220', 'US_DNSS'], ['SaleOfInfo']],
    [
        [
            exports.UNKNOWN_DEFAULT_EXPERIENCE,
            // 'UCPA'
        ],
        [],
    ],
];
exports.DEFAULT_REGIME_PURPOSE_OPT_OUTS = [
    exports.GDPR_PURPOSES,
];
exports.DEFAULT_EXPERIENCE_PURPOSE_OPT_OUTS = Object.fromEntries(exports.DEFAULT_REGIME_PURPOSE_OPT_OUTS.map(([regimes, purposes]) => regimes.map((regime) => [regime, purposes])).flat());
exports.DEFAULT_EXPERIENCE_PURPOSE_SCOPES = Object.fromEntries(exports.DEFAULT_REGIME_TRACKING_PURPOSE_SCOPES.map(([regimes, purposes]) => regimes.map((regime) => [regime, purposes])).flat());
// default to []
exports.REGIME_TIMEZONES = {};
// default to 20
exports.REGIME_DISPLAY_PRIORITY = {
    GDPR: 10,
    Unknown: 100,
};
/* eslint-disable max-len */
/**
 * These TCF Purposes cannot be allowed to process under legitimate interest legal basis
 * Source:
 * https://iabeurope.eu/iab-europe-transparency-consent-framework-policies/#:~:text=Appendix%20A:%20Definitions%20Of%20Purposes,%20Features%20And%20Categories%20Of%20Data
 */
exports.DEFAULT_RESTRICT_LEGIT_INTEREST_PROCESSING = [1, 3, 4, 5, 6];
/* eslint-enable max-len */
//# sourceMappingURL=constants.js.map